<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header" style="margin-bottom:20px">
        <h4 class="account-card-title">预约反馈</h4>
      </div>
      <div class="form">
        <el-form :model="ruleForm" ref="ruleForm" label-width="150px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="预告标题:">
                <span>{{ ruleForm.title }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="预告编号:">
                <span>{{ ruleForm.code }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="看货开始时间:">
                <span>{{ ruleForm.inspectStartTime }} </span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="看货截止时间:">
                <span>{{ ruleForm.inspectEndTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="看货地点:">
                <span>{{ ruleForm.inspectAddress }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="titlepen">
        <span class="titlepenleft">已选择{{ number }}个竞买人</span>
        <el-button type="primary" class="titlepenright" @click="operation"
          >批量反馈</el-button
        >
        <el-table
          border
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="selectable"
            align="center"
          >
          </el-table-column>
          <el-table-column label="序号" type="index" width="50" align="center">
          </el-table-column>
          <el-table-column
            label="竞买人"
            width="120"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span class="cell-link" @click="oncompName(scope.row)">
                {{ scope.row.compName }}</span
              ></template
            >
          </el-table-column>
          <el-table-column
            prop="inspectApplyTime"
            label="申请看货时间"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="straddrEc"
            label="所在地"
            width="120"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="inspectFeedbackTime"
            label="反馈看货时间"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="inspectApplyContName"
            label="联系人"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="inspectApplyContMobile"
            label="联系方式"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="auditWhether" label="状态" align="center">
            <template slot-scope="scope">
              <span>
                {{ scope.row.auditWhether == 1 ? '已反馈' : '未反馈' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row)"
                v-if="scope.row.auditWhether == 0"
                type="text"
                size="small"
                >反馈</el-button
              >
              <el-button
                @click="handleClick(scope.row)"
                v-if="scope.row.auditWhether == 1"
                type="text"
                size="small"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="反馈说明"
        :visible.sync="dialogTableVisible"
        :modal-append-to-body="false"
      >
        <el-form
          :model="formAudit"
          ref="formAudit"
          label-width="120px"
          size="small"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="联系人:"
                prop="inspectFeedbackContName"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input
                  v-model="formAudit.inspectFeedbackContName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="联系方式:"
                prop="inspectFeedbackContMobile"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input
                  v-model="formAudit.inspectFeedbackContMobile"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                label="看货时间:"
                prop="inspectFeedbackTime"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-date-picker
                  v-model="formAudit.inspectFeedbackTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  default-time="9:00:00"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="每家看货人数:"
                prop="inspectFeedbackNum"
                :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
              >
                <el-input
                  v-model="formAudit.inspectFeedbackNum"
                  placeholder="请输入内容"
                  oninput="value=value.replace(/[^\d]/g,'')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            label="看货地点:"
            :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
            prop="inspectFeedbackPlace"
          >
            <el-input
              v-model="formAudit.inspectFeedbackPlace"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="说明:">
            <el-input
              v-model="formAudit.inspectFeedbackRemark"
              placeholder="请填写看货联系人、联系方式和看货要求"
              type="textarea"
              :rows="3"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="附件:">
            <template slot="label">
              附件
              <el-tooltip effect="light" placement="top-start">
                <template slot="content">
                  可上传doc、docx、xls、xslx、pdf格式文件，最多3个文件，每个文件不超过5M
                </template>
                <i class="el-icon-question table-worming">&nbsp;</i>
              </el-tooltip>
              :
            </template>
            <on-price
              :multiple="true"
              accept="*"
              :type="'primary'"
              @fileDataSingle="noticeFiles"
              :fileList="formAudit.noticeFiles"
            ></on-price>
          </el-form-item>
        </el-form>
        <!-- <el-form-item label="说明：">
            <template slot="label">
              共有 {{ number }} 个竞买人报名同时反馈
            </template>
            <el-input
              v-model="form.inspectFeedbackRemark"
              type="textarea"
              :rows="5"
            ></el-input>
          </el-form-item> -->

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogTableVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('formAudit')"
            >确 定</el-button
          >
        </div>
      </el-dialog>

      <el-button @click="down" class="down">返回</el-button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      auditVisible: true,
      number: '0',
      formAudit: {
        inspectFeedbackTime: '',
        inspectFeedbackNum: null,
        inspectFeedbackRemark: '',
        noticeFiles: [],
        inspectFeedbackPlace: '',
        inspectFeedbackContName: '',
        inspectFeedbackContMobile: ''
      },
      ruleForm: {
        title: '',
        code: '',
        bidStartTime: '',
        instructions: ''
      },
      tableData: [{ id: 1, compName: 'kkkkkkk' }],
      multipleSelection: [],
      dialogTableVisible: false,
      choose: ''
    }
  },
  computed: {
    typeId() {
      return this.$route.query.id
    }
  },
  created() {
    this.noticeGet()
    this.sellerInspectList()
  },
  methods: {
    noticeFiles(val) {
      this.formAudit.noticeFiles = val
    },
    async noticeGet() {
      let data = await this.$api.notice.getNoticeInfo(this.typeId)
      this.ruleForm = data
    },
    async sellerInspectList() {
      let data = await this.$api.serviceProvider.preInspectList({
        noticeId: this.typeId,
        pageIndex: 1,
        pageSize: 99999
      })
      this.tableData = data.data

      //   this.ruleForm = data
    },
    operation() {
      // console.log('ss')
      // this.dialogTableVisible = true
      // console.log(this.dialogTableVisible )
      if (this.multipleSelection.length === 0) {
        this.$message.warning('至少选择一个竞买人')
      } else {
        this.dialogTableVisible = true
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.number = this.multipleSelection.length
    },
    selectable(row) {
      if (row.auditWhether == 0) {
        return true
      }
    },
    async submitForm(formAudit) {
      this.$refs[formAudit].validate(valid => {
        if (valid) {
          this.submit()
        } else {
          return false
        }
      })
    },
    async submit() {
      let arr = this.multipleSelection.map(item => {
        return item.id
      })
      let query = {
        fileList: this.formAudit.noticeFiles,
        inspectFeedbackTime: this.formAudit.inspectFeedbackTime,
        inspectFeedbackNum: this.formAudit.inspectFeedbackNum,
        inspectFeedbackRemark: this.formAudit.inspectFeedbackRemark,
        inspectFeedbackPlace: this.formAudit.inspectFeedbackPlace,
        inspectFeedbackContName: this.formAudit.inspectFeedbackContName,
        inspectFeedbackContMobile: this.formAudit.inspectFeedbackContMobile,
        noticeId: this.typeId,
        inspectIdList: arr
      }
      let data = await this.$api.serviceProvider.feedbackBatch(query)
      this.dialogTableVisible = false
      if (data) {
        this.$message.success('审批成功')
        this.formAudit.inspectFeedbackTime = ''
        this.formAudit.inspectFeedbackNum = null
        this.formAudit.inspectFeedbackRemark = ''
        this.formAudit.noticeFiles = []
        this.formAudit.inspectFeedbackPlace = ''
        this.formAudit.inspectFeedbackContName = ''
        this.formAudit.inspectFeedbackContMobile = ''
        this.sellerInspectList()
      }
    },
    oncompName(o) {
      let query = {
        compCode: o.compCode,
        source: 'service'
      }
      this.$openNewPage('BuyerInformation', query)
    },
    handleClick(o) {
      let query = {
        noticeID: this.typeId,
        typequery: o.auditWhether == 1 ? '1' : '',
        compCode: o.compCode
      }
      this.$router.push({ name: 'ApplicationInspectionSingleForete', query })
    },
    down() {
      this.$router.push({ name: 'ServiceForetellManagement' })
    }
  }
}
</script>
<style lang="less" scoped>
.titleone {
  margin: 5px;
  margin-top: 15px;
  width: 10px;
  height: 22px;
  background: #2587ff;
  float: left;
}
.title {
  padding: 10px;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 20px;
  background: #ecf5ff;
  font-size: 15px;
  line-height: 15px;
}
.titlesplic {
  float: right;
  color: royalblue;
  cursor: pointer;
}
.form {
  padding-right: 50px;
  padding-left: 100px;
}
.instructions {
  min-height: 120px;
  line-height: 20px;
  margin-left: 60px;
}
.titlepen {
  padding-left: 50px;
  position: relative;
}
.titlepenleft {
  position: absolute;
  // margin-left: 10px;
  top: 20px;
  left: 50x;
}
.titlepenright {
  float: right;
}
.down {
  margin: 20px 550px;
}
</style>
